// extracted by mini-css-extract-plugin
export default {"search":"Search_search__JtbP4","search__ico":"Search_search__ico__mcRKV","search__input":"Search_search__input__k7uZ1"};